module.exports = React;


/*****************
 ** WEBPACK FOOTER
 ** external "React"
 ** module id = 3
 ** module chunks = 0
 **/